import type { MoodEntry } from '../../types/mood';

export const peaceful: MoodEntry = {
  id: 'peaceful',
  name: 'Peaceful',
    synonyms: ['bright', 'buoyant', 'energised', 'lighthearted', 'hopeful'],
    related: ['optimistic', 'joyful', 'encouraged', 'motivated'],
    antonyms: ['conflicted', 'unsettled', 'irritated', 'stressed', 'turbulent', 'conflicted','sad','blue','hurt','upset','angry','frustrated','stressed','tense','upset','worked up','emotional','down',
  'irritated',
  'angry',
  'frustrated',
  'stressed',
  'turbulent',
  'sad',
  'hurt',
  'upset',
  'down',
  'blue',
  'emotional',
  'worked up'
],
    behaviours: ['quicker steps', 'open gestures', 'warm tone', 'increased curiosity'],
    actions: ['send a kind message', 'play a favourite song', 'refresh your space', 'share a small win'],
    phrases: ['Let the light in.', 'Carry the good forward.', 'Small joys matter.', 'Energy rises when shared.'],
    quotes: [
      '“Where there is light, there is joy.” — Anne Frank',
      '“Happiness is not something ready-made. It comes from your own actions.” — Dalai Lama'
    ],
    palette: ['#FFE8A3', '#FFD97A', '#FFCC66', '#F9B94E'],
    season: 'Spring'
};